import React, {useState} from 'react'
import styled from "styled-components"
import { Marginer } from "../../Components/marginer";
import Swal from 'sweetalert2'
import { Redirect } from 'react-router-dom';
import PortFolio from "../Portfolio.js"
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom'
import {withRouter} from "react-router-dom"
import axios from 'axios';
  
const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex;
`;

const Title = styled.h2`
	margin: 0;
	line-height: 1.4;
	color: #000;
	font-weight: 700;
	font-size: 50px;
`;

const Label = styled.label`
	margin: 0;
	line-height: 1.4;
	color: #000;
	font-weight: 700;
	font-size: 25px;
`;

const Input = styled.input`
  font-size: 18px;
  padding: 10px;
  margin: 10px;
  background: #00ffab;
  border: none;
  border-radius: 5px;
  ::placeholder {
    color: palevioletred;
  }
`;

const Button = styled.button`
  border: none;
  outline: none;
  color: #fff;
  padding: 6px 1em;
  font-size: ${({ size }) => (size ? size + "px" : "20px")};
  font-weight: 600;
  border-radius: 5px;
  margin-left: 50px;
  background-color: #2a9d8f;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  &:hover {
    background-color: #21867a;
  }
  &:focus {
    outline: none;
  }
`;

class index extends React.Component {
	state = {
		toPortPage: false,
	}
	constructor(props) {
		super(props)
	
		this.state = {
			 gitName: ''
		}
		this.handleName=this.handleName.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
	}

	emptytext()
  	{
    Swal.fire({
      title: 'GitToPort',
      text: "Please enter the Username",
      type: 'warning',
      
    })
  	}

  	incorrect()
  	{
    Swal.fire({
      title: 'GitToPort',
      text: "Please enter valid Github Username",
      type: 'warning',
      
    })
  	}

	handleName(event) {
    	this.setState({value: event.target.value});
	}

	async handleSubmit(event) {
	    //alert('A name was submitted: ' + this.state.value);
	    //const history = useHistory();
	    event.preventDefault();
		if(!this.state.value){
			//alert('please enter name')
			this.emptytext()

			//popup for no name provided
		}
		else{
			const response = await fetch(
				`https://api.github.com/users/${this.state.value}`
			);
			if(response.status == 404){
				//alert('No User found')
				this.incorrect()
				//here popup 
			}
			else{
				//alert('User Found')
				//Here it should route to portfolio.js
				//return <Redirect  to= "../Portfolio.js" />
				//return <PortFolio />
				//return <Link to="../Portfolio.js" />
				//this.props.history.push('../Portfolio/');
				//history.push(`../Portfolio`);
				//withRouter('../PortFolio')
				//this.state.toPortPage= true
				this.setState({ toPortPage: true})

				//return <Link to="/Portfolio/" />

			}
		}
		
	}

	render() {
		const { toPortPage } = this.state
		if(this.state.toPortPage === true)
		{
			/*return <Redirect to='/Portfolio/' />
			return <Link to={{
				pathname: '/Portfolio/',
				state: {
					fromNotifications: true
				}
			}}>abc</Link>*/

			return <Redirect 
					to={{
						pathname: "/Portfolio/",
						state: { username: this.state.value}
					}}
				/>
		}

		return (
		<InputContainer>
		<Title> Enter Your Github Username</Title>
		<Marginer direction="vertical" margin="4em" />
		<form onSubmit={this.handleSubmit}>
        	<Label>
        	  Username:
          	<Input type="text" value={this.state.value} onChange={this.handleName} />
          	</Label>
        	<Marginer direction="vertical" margin="2em" />
        	<Button onClick={this.handleSubmit}>Submit</Button>
      	</form>
      	</InputContainer>
		)
	}
}

export default index